import React, { Component } from "react";
import { Button, Form } from "semantic-ui-react";

import { connect } from "react-redux";

import { updateOrganizationName } from "../../actions/organization";

class OrganizationInformationForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      organizationName: props.organizationName,
      submitting: false,
      error: false
    };
  }

  validateForm() {
    return this.state.organizationName.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
      error: false
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    this.setState({
      submitting: true
    });
    updateOrganizationName(this.state.organizationName)
      .then(() => {
        this.setState({
          error: false
        });
      })
      .catch(e => {
        this.setState({
          error: e
        });
      })
      .finally(() => {
        this.setState({
          submitting: false
        });
      });
  };

  render() {
    return (
      <Form loading={this.state.submitting} onSubmit={this.handleSubmit}>
        <Form.Group widths="equal">
          <Form.Input
            icon="building"
            iconPosition="left"
            label="Company name"
            placeholder="Company name"
            value={this.state.organizationName}
            error={!!this.state.error}
            onChange={this.handleChange}
            id="organizationName"
          />
        </Form.Group>
        <Button
          type="submit"
          primary
          disabled={!this.validateForm() || this.state.submitting}
        >
          Save
        </Button>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  organizationName: state.organization.name
});

export default connect(mapStateToProps)(OrganizationInformationForm);



// WEBPACK FOOTER //
// ./frontend/src/components/forms/OrganizationInformationForm.js